import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useState, useEffect } from 'react';
import { ArrowDownSquare } from 'react-bootstrap-icons';


interface TimeWindowDropdownProps {
    outputTimeWindowString: (month: string) => void;
}
interface TimeDropdownOption {
    display: string;
    value: string;
}

function TimeWindowDropdown({outputTimeWindowString}: TimeWindowDropdownProps){
    var today = new Date();
    const currentYear = today.getFullYear()
    const years = Array.from({ length: 50 }, (v, i) => currentYear + i);
    const initYear = today.getFullYear()
    const initMonth = today.getMonth()

    let [window, setWindow] = useState("");
    let [options, setOptions] = useState<TimeDropdownOption[]>([]);


    /*
    const updateParentState = () => {
        outputYear(year);
        outputMonth(month);
    }*/
    const updateWindow = (value: string) => {
        setWindow(value);
    }

   // Generate 24 hours of options starting from midnight
    const generateHourlyOptions = (): TimeDropdownOption[] => {
        const list: TimeDropdownOption[] = [];
        const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        

        //7 days of times
        let start_date = new Date()
        for (let i = 1; i < (24*7); i++) {
            const result = new Date(start_date); // Clone the original date
            result.setHours(result.getHours() + i);
            let year = result.getFullYear();
            let mm = String(result.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            let month = months[result.getMonth()];
            let day = days[result.getDay()];
            let dd = String(result.getDate()).padStart(2, '0');
            let hour = result.getHours();

            const formattedDate = `${day}, ${month} ${dd}, ${year} ${hour}:00:00 CST`;
            const datevalue = `${year}-${mm}-${dd} ${hour}:00:00`;
        
            /**
             * No Devlivery Before 8am
             * No Delivery After 7pm
             * 2 Hour Delivery Window
             * No Sunday Delivery
             */
            if (hour < 19 && hour > 8 && (hour % 2 === 0) && result.getDay() != 0) {
                list.push({value: datevalue, display: formattedDate});
            }
        }
        return list;
    };

    /* Component Init */
    useEffect(() => {
        if(options.length < 1){
            setOptions(generateHourlyOptions());
        }
        outputTimeWindowString(window);
        console.log(window)
    }, [options, window]);

    return (
        <> 
            <Container className="p-4">
                <Row className="border py-2">
                    <Col xs={{span: 11}}>
                            <select id={"spoofvalue"} className="border-0 input-fill no-generic-input-styles" aria-describedby="dob_month" value={window} onChange={(e) => updateWindow(e.target.value)}>
                                <option value="" className="dropdown-item" >Select Delivery Window</option>
                                {options.map((time, index) => (
                                    <option key={index} value={time.value}>
                                        {time.display}
                                    </option>
                                    ))
                                }
                            </select>
                    </Col>
                    <Col xs={{span: 1}}>
                        <ArrowDownSquare size={20} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default TimeWindowDropdown;